import {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import API from "../../services/api";
import toast from "react-hot-toast";

function ReceivePayment() {

  const navigate =
    useNavigate();

  const { id } =
    useParams();

  const [loading,
    setLoading] =
    useState(true);

  const [saving,
    setSaving] =
    useState(false);

  const [invoice,
    setInvoice] =
    useState(null);

  const [wallets,
    setWallets] =
    useState([]);

  const [payments,
    setPayments] =
    useState([]);

  const [form,
    setForm] =
    useState({

      wallet_id: "",

      payment_date:
        new Date()
          .toISOString()
          .split("T")[0],

      amount: "",

      remarks: ""

    });

  useEffect(() => {

    loadData();

  }, []);

  const loadData =
    async () => {

      try {

        setLoading(true);

        const res =
          await API.get(
            `/invoices/${id}/payment`
          );

        setInvoice(
          res.data.invoice
        );

        setWallets(
          res.data.wallets || []
        );

        setPayments(
          res.data.payments || []
        );

        if (
          res.data.invoice?.wallet_id
        ) {

          setForm(prev => ({

            ...prev,

            wallet_id:
              res.data.invoice.wallet_id

          }));

        }

      } catch (err) {

        console.log(err);

      } finally {

        setLoading(false);

      }

    };

  const submit =
    async (e) => {

      e.preventDefault();

      if (
        Number(form.amount) <= 0
      ) {

        return toast.error(
          "Enter payment amount"
        );

      }

      if (
        Number(form.amount) >
        Number(invoice.remaining_amount)
      ) {

        return toast.error(
          "Payment cannot exceed remaining amount."
        );

      }

      try {

        setSaving(true);

        await API.post(
          `/invoices/${id}/payment`,
          form
        );

        toast.success(
          "Payment Received Successfully"
        );

        loadData();

        setForm(prev => ({

          ...prev,

          amount: "",

          remarks: ""

        }));

      } catch (err) {

        toast.error(
          err.response?.data?.message ||
          "Something went wrong"
        );

      } finally {

        setSaving(false);

      }

    };

  if (loading) {

    return (

      <div
        className="
        text-center
        py-20
        text-xl
        "
      >
        Loading...
      </div>

    );

  }

  return (

<div>

    <div
        className="
        flex
        justify-between
        items-center
        mb-8
        "
    >

        <h1
            className="
            text-4xl
            font-bold
            "
        >
            Receive Payment
        </h1>

        <button
            onClick={() => navigate(-1)}
            className="
            px-5
            py-3
            rounded-xl
            bg-gray-700
            "
        >
            Back
        </button>

    </div>

    {/* Invoice Summary */}

    <div
        className="
        bg-[#111]
        rounded-2xl
        p-6
        border
        border-yellow-500/20
        "
    >

        <div
            className="
            grid
            md:grid-cols-2
            lg:grid-cols-4
            gap-6
            "
        >

            <div>

                <p className="text-gray-400">
                    Invoice No
                </p>

                <h2 className="text-xl font-bold mt-2">
                    {invoice.invoice_no}
                </h2>

            </div>

            <div>

                <p className="text-gray-400">
                    Customer
                </p>

                <h2 className="text-xl font-bold mt-2">
                    {invoice.customer_name}
                </h2>

            </div>

            <div>

                <p className="text-gray-400">
                    Invoice Date
                </p>

                <h2 className="text-xl font-bold mt-2">
                    {new Date(invoice.invoice_date).toDateString()}
                </h2>

            </div>

            <div>

                <p className="text-gray-400">
                    Status
                </p>

                <span
                    className={`px-3 py-1 rounded-full text-sm font-bold
                    ${
                        invoice.payment_status==="paid"
                        ? "bg-green-500/20 text-green-400"
                        : invoice.payment_status==="partial"
                        ? "bg-yellow-500/20 text-yellow-400"
                        : "bg-red-500/20 text-red-400"
                    }`}
                >
                    {invoice.payment_status}
                </span>

            </div>

        </div>

    </div>

    {/* Amount Cards */}

    <div
        className="
        grid
        md:grid-cols-3
        gap-6
        mt-8
        "
    >

        <div
            className="
            bg-[#111]
            rounded-2xl
            p-6
            "
        >

            <p className="text-gray-400">
                Grand Total
            </p>

            <h2
                className="
                text-3xl
                font-bold
                text-green-400
                mt-3
                "
            >
                ₹{Number(invoice.grand_total).toFixed(2)}
            </h2>

        </div>

        <div
            className="
            bg-[#111]
            rounded-2xl
            p-6
            "
        >

            <p className="text-gray-400">
                Paid Amount
            </p>

            <h2
                className="
                text-3xl
                font-bold
                text-blue-400
                mt-3
                "
            >
                ₹{Number(invoice.paid_amount).toFixed(2)}
            </h2>

        </div>

        <div
            className="
            bg-[#111]
            rounded-2xl
            p-6
            "
        >

            <p className="text-gray-400">
                Remaining
            </p>

            <h2
                className="
                text-3xl
                font-bold
                text-red-400
                mt-3
                "
            >
                ₹{Number(invoice.remaining_amount).toFixed(2)}
            </h2>

        </div>

    </div>

    {/* Payment Form */}

    <form
        onSubmit={submit}
        className="
        mt-8
        bg-[#111]
        rounded-2xl
        p-6
        "
    >

        <h2
            className="
            text-2xl
            font-bold
            mb-6
            "
        >
            Receive New Payment
        </h2>

        <div
            className="
            grid
            md:grid-cols-2
            gap-6
            "
        >

            <div>

                <label className="block mb-2">
                    Wallet
                </label>

                <select
                    required
                    value={form.wallet_id}
                    onChange={(e)=>
                        setForm({
                            ...form,
                            wallet_id:e.target.value
                        })
                    }
                    className="
                    w-full
                    p-3
                    rounded-xl
                    bg-black
                    border
                    border-yellow-500/20
                    "
                >

                    <option value="">
                        Select Wallet
                    </option>

                    {wallets.map(wallet=>(
                        <option
                            key={wallet.id}
                            value={wallet.id}
                        >
                            {wallet.wallet_name}
                        </option>
                    ))}

                </select>

            </div>

            <div>

                <label className="block mb-2">
                    Payment Date
                </label>

                <input
                    type="date"
                    required
                    value={form.payment_date}
                    onChange={(e)=>
                        setForm({
                            ...form,
                            payment_date:e.target.value
                        })
                    }
                    className="
                    w-full
                    p-3
                    rounded-xl
                    bg-black
                    border
                    border-yellow-500/20
                    "
                />

            </div>

            <div>

                <label className="block mb-2">
                    Amount
                </label>

                <input
                    type="number"
                    required
                    max={invoice.remaining_amount}
                    value={form.amount}
                    onChange={(e)=>
                        setForm({
                            ...form,
                            amount:e.target.value
                        })
                    }
                    className="
                    w-full
                    p-3
                    rounded-xl
                    bg-black
                    border
                    border-yellow-500/20
                    "
                />

            </div>

            <div>

                <label className="block mb-2">
                    Remarks
                </label>

                <input
                    type="text"
                    value={form.remarks}
                    onChange={(e)=>
                        setForm({
                            ...form,
                            remarks:e.target.value
                        })
                    }
                    className="
                    w-full
                    p-3
                    rounded-xl
                    bg-black
                    border
                    border-yellow-500/20
                    "
                />

            </div>

        </div>

        <div className="mt-8">

            <button
                type="submit"
                disabled={
                    saving ||
                    invoice.payment_status==="paid"
                }
                className="
                bg-yellow-500
                text-black
                px-8
                py-3
                rounded-xl
                font-semibold
                disabled:opacity-50
                "
            >
                {
                    saving
                    ? "Receiving..."
                    : "Receive Payment"
                }
            </button>

        </div>

    </form>
          {/* PAYMENT HISTORY */}

      <div
        className="
        mt-8
        bg-[#111]
        rounded-2xl
        overflow-hidden
        "
      >

        <div
          className="
          p-6
          border-b
          border-yellow-500/20
          "
        >
          <h2
            className="
            text-2xl
            font-bold
            "
          >
            Payment History
          </h2>
        </div>

        {
          payments.length === 0 ? (

            <div
              className="
              p-10
              text-center
              text-gray-400
              "
            >
              No Payment History
            </div>

          ) : (

            <>
              {/* Desktop */}

              <div className="hidden md:block overflow-x-auto">

                <table className="w-full">

                  <thead>

                    <tr className="border-b border-yellow-500/20">

                      <th className="p-4 text-left">
                        Date
                      </th>

                      <th className="p-4 text-left">
                        Wallet
                      </th>

                      <th className="p-4 text-center">
                        Amount
                      </th>

                      <th className="p-4 text-left">
                        Remarks
                      </th>

                      <th className="p-4 text-left">
                        Received By
                      </th>

                    </tr>

                  </thead>

                  <tbody>

                    {
                      payments.map(payment => (

                        <tr
                          key={payment.id}
                          className="
                          border-b
                          border-yellow-500/10
                          "
                        >

                          <td className="p-4">
                            {new Date(payment.created_at).toLocaleString()}
                          </td>

                          <td className="p-4">
                            {payment.wallet_name}
                          </td>

                          <td
                            className="
                            p-4
                            text-center
                            text-green-400
                            font-bold
                            "
                          >
                            ₹{Number(payment.amount).toFixed(2)}
                          </td>

                          <td className="p-4">
                            {payment.remarks || "-"}
                          </td>

                          <td className="p-4">
                            {payment.sold_by_name}
                          </td>

                        </tr>

                      ))
                    }

                  </tbody>

                </table>

              </div>

              {/* Mobile */}

              <div className="md:hidden p-4 space-y-4">

                {
                  payments.map(payment => (

                    <div
                      key={payment.id}
                      className="
                      bg-black
                      rounded-xl
                      p-4
                      border
                      border-yellow-500/20
                      "
                    >

                      <div className="flex justify-between">

                        <span>Date</span>

                        <span>
                          {new Date(payment.created_at).toLocaleString()}
                        </span>

                      </div>

                      <div className="flex justify-between mt-2">

                        <span>Wallet</span>

                        <span>
                          {payment.wallet_name}
                        </span>

                      </div>

                      <div className="flex justify-between mt-2">

                        <span>Amount</span>

                        <span className="text-green-400">

                          ₹{Number(payment.amount).toFixed(2)}

                        </span>

                      </div>

                      <div className="flex justify-between mt-2">

                        <span>Received By</span>

                        <span>
                          {payment.sold_by_name}
                        </span>

                      </div>

                      <div className="mt-3">

                        <p className="text-gray-400 text-sm">
                          Remarks
                        </p>

                        <p>
                          {payment.remarks || "-"}
                        </p>

                      </div>

                    </div>

                  ))
                }

              </div>

            </>

          )

        }

      </div>

    </div>

  );

}

export default ReceivePayment;